if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"OP-WRAPPER","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(38[58]8|1747|2164|4976|6262|8096|9817)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}